import React from 'react';
import PropTypes from 'prop-types';

import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobCompletionPhotos = ({
  formikBag,
  getFormFieldsById,
  text,
}) => {
  return (
    <div styleName='card'>
      <span styleName='cardTitle'>
        Completion Photos
      </span>

      {text && (
        <SrBox paddingTop='8px'>
          <SrText
            font='greycliff'
            fontSize='14px'
            weight='500'
            lineHeight='20px'
          >
            {text}
          </SrText>
        </SrBox>
      )}

      <div>
        <SrFormikField
          formField={getFormFieldsById('completionPhotoUrls')}
          formikBag={formikBag}
          theme={SR_FIELD_THEME_ADOBE}
        />
      </div>
    </div>
  );
};

SrSunSetupDriverJobCompletionPhotos.propTypes = {
  formikBag: PropTypes.object.isRequired,
  getFormFieldsById: PropTypes.func.isRequired,
  text: PropTypes.string,
};

SrSunSetupDriverJobCompletionPhotos.displayName = 'SrSunSetupDriverJobCompletionPhotos';

export default SrSunSetupDriverJobCompletionPhotos;
